module.exports = __webpack_public_path__ + "static/media/accessory__PIRSensor.6cf197bb.jpg";